export const FORGOT_STATES = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  EMAIL_NOT_FOUND: 'email_not_found',
  ACCOUNT_BLOCKED: 'account_blocked',
  NOT_ACTIVATED: 'not_activated',
} as const;

export type ForgotPasswordState = (typeof FORGOT_STATES)[keyof typeof FORGOT_STATES];
